import keyMirror from 'keymirror';

export const ActionTypes = keyMirror({
  SET_COMPANIES: null,
  PUSH_COMPANY: null,
});

export interface ICompaniesState {
  companies: Company[],
}